import { render } from "./Medico_Interconsulta.vue?vue&type=template&id=ef1858c0&scoped=true"
import script from "./Medico_Interconsulta.vue?vue&type=script&lang=js"
export * from "./Medico_Interconsulta.vue?vue&type=script&lang=js"

import "./Medico_Interconsulta.vue?vue&type=style&index=0&id=ef1858c0&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1858c0"]])

export default __exports__